import { useTranslation } from "next-i18next";

import { AppLayout } from "common/layouts/AppLayout";

import { ROUTES } from "constants/routes";

interface Props {
  children: React.ReactNode,
}

export function RootLayout({ children }: Props) {
  const { t } = useTranslation("host");

  return (
    <AppLayout
      menu={[
        {
          title: t("rootLayout.home"),
          url: ROUTES.HOME
        },
        {
          title: t("rootLayout.listings"),
          url: ROUTES.LISTINGS.BASE
        },
        {
          title: t("rootLayout.projects"),
          url: ROUTES.PROJECTS.BASE
        },
        {
          title: t("rootLayout.users"),
          url: ROUTES.USERS.BASE
        },
        {
          title: t("rootLayout.qrCodes"),
          url: ROUTES.QR_CODES.BASE
        },
        {
          title: t("rootLayout.seedData"),
          url: ROUTES.SEED_DATA.BASE
        },
        // TODO Waiting for UX
        // {
        //   title: t("rootLayout.subscriptions"),
        //   url: "/subscriptions"
        // },
      ]}
      portal="host"
    >
      {children}
    </AppLayout>
  )
}
